<template>
  <div class="more">
    <v-app-bar app color="primary" dense class="header primaryText--text">
      <v-row>
        <v-col cols="3">
          <v-app-bar-nav-icon v-if="showLangSwitcher" @click="setNextLanguage" class="ml-2" style="width:auto;">
            <LanguageIcon></LanguageIcon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="6" class="d-flex justify-center align-center">
          <div>
            <v-toolbar-title class="header-title2">{{ $t("more") }}</v-toolbar-title>
          </div>
        </v-col>

        <v-col cols="3" align-self="end" style="text-align:right"> </v-col>
      </v-row>
    </v-app-bar>

    <v-container>
      <v-list>
        <v-list-item @click="memberProfile">
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("profile") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >

        <v-list-item v-show="$store.state.pointEnabled" @click="memberPoints">
          <v-list-item-icon>
            <v-icon>mdi-alpha-p-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("points") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >

        <v-list-item v-show="$store.state.giftcardEnabled" @click="memberGiftcard">
          <v-list-item-icon>
            <v-icon>mdi-wallet-giftcard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("giftcard") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >

        <v-list-item @click="openAddressList">
          <v-list-item-icon>
            <v-icon>mdi-map-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("addressbook") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openOrderHistory">
          <v-list-item-icon>
            <v-icon>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("order_history") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >

        <v-list-item v-show="$store.state.termsOfUseContent != null" @click="openTermsOfUse">
          <v-list-item-icon>
            <v-icon>mdi-text-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("term_of_use") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >

        <v-list-item class="logout" @click="memberLogout">
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
          </v-list-item-content></v-list-item
        >
      </v-list>

      <div class="app-version">
        App {{ $store.getters.appVersion.version }} ({{ $store.state.kernelNo }})
        <span class="pl-1" v-if="$store.state.serverBuildNo > 0">Server {{$store.state.serverBuildNo}}</span>
      </div>
    </v-container>

    <CompanyTermsOfUseDialog ref="termsOfUseDialog"></CompanyTermsOfUseDialog>
    <WebPageDialog ref="webPageDialog"></WebPageDialog>
  </div>
</template>

<script>
// @ is an alias to /src
import CompanyTermsOfUseDialog from "@/dialogs/CompanyTermsOfUseDialog";
import WebPageDialog from "@/dialogs/WebPageDialog";

import LanguageIcon from "@/components/LanguageIcon.vue";

export default {
  name: "More",
  components: {
    CompanyTermsOfUseDialog,
    WebPageDialog,
    LanguageIcon,
  },

  methods: {
    memberProfile() {
      this.$root.memberProfileDialog();
    },

    memberPoints() {
      this.$root.memberPointDialog();
    },

    memberGiftcard() {
      this.$store.state.appBar.showDrawer = false;

      this.rest_getMember(this.$store.state.member.PhoneId)
        .then(resp => {
          if (resp.result == "ok") {
            this.$store.state.member = resp.record.child;

            this.navName("GiftCard");   
          }
        });
    },

    openAddressList() {
      this.$root.addressListDialog();
    },

    openOrderHistory() {
      this.$root.orderHistoryDialog();
    },

    openTermsOfUse() {
      this.$refs.termsOfUseDialog.open();
    },

    openMRSWebPage() {
      this.$refs.webPageDialog.open("MRS Digi Inc.", "https://www.mrsdigi.com");
    },

    memberLogout() {
      let message = "";

      message += this.$t("confirm_logout");
      this.$root.confirmDialog(this.$t("confirm_title"), "", message).then(agree => {
        if (agree) {
          this.setLastLogin({});
          this.$store.state.member = null;
          this.$store.state.promos = [];

          this.navName("Home");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-version {
  font-size: 0.8em;
  color: gray;

  position: absolute;
  bottom: calc(8px + env(safe-area-inset-bottom));
  right: 16px;
  //margin-left: 16px;
}

.logout {
  .v-icon {
    color: var(--v-accent-base);
  }

  .v-list-item__title {
    color: var(--v-accent-base);
  }
}
</style>
